import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Heart, CheckCircle2, AlertCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SupportSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState('checking'); // checking | paid | pending | error
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = params.get('session_id');
    if (!sessionId) { setState('error'); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      attempts.current += 1;
      try {
        const r = await axios.get(`${API}/payments/status/${sessionId}`);
        if (r.data.payment_status === 'paid') { setState('paid'); return; }
        if (['expired', 'failed'].includes(r.data.payment_status)) { setState('error'); return; }
      } catch (e) { /* keep polling */ }
      if (attempts.current >= 10) { setState('pending'); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-[#1a1214] text-stone-100 grid place-items-center px-6" style={{ fontFamily: 'Georgia, serif' }}>
      <div className="max-w-md text-center">
        {state === 'checking' && (<>
          <Loader2 className="w-10 h-10 animate-spin mx-auto text-[#C9A961]" />
          <h1 className="text-2xl mt-5" data-testid="support-status-checking">Confirming your contribution…</h1>
        </>)}
        {state === 'paid' && (<>
          <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-400" />
          <h1 className="text-3xl mt-5" data-testid="support-status-paid">Thank you!</h1>
          <p className="text-stone-300 mt-3 leading-relaxed">Your contribution means the world. A receipt is on its way to your inbox — and the next glass we raise on air is for you. <Heart className="w-4 h-4 inline text-[#C9A961]" /></p>
        </>)}
        {state === 'pending' && (<>
          <Loader2 className="w-10 h-10 mx-auto text-[#C9A961]" />
          <h1 className="text-2xl mt-5">Payment is processing</h1>
          <p className="text-stone-400 mt-3">It's taking a little longer than usual — your receipt email will confirm once it completes.</p>
        </>)}
        {state === 'error' && (<>
          <AlertCircle className="w-12 h-12 mx-auto text-red-400" />
          <h1 className="text-2xl mt-5" data-testid="support-status-error">Something went wrong</h1>
          <p className="text-stone-400 mt-3">We couldn't confirm the payment. If you were charged, the receipt email is your proof — otherwise feel free to try again.</p>
        </>)}
        <Link to="/support" className="inline-block mt-8 text-[#C9A961] underline underline-offset-4" data-testid="support-back-link">Back to support page</Link>
      </div>
    </div>
  );
}
